import React from 'react';

const AcademicCalender = () => {
  return (
    <div>
      AcademicCalender
      AcademicCalender
    </div>
  );
}

export default AcademicCalender;
